import '../../styles/frontend/hero.css'

export function setHeroContainerHeight() {
    const heroContainers = document.querySelectorAll('.dd-hero-fixed');

    if (heroContainers.length) {
        const windowHeight = window.innerHeight;

        heroContainers.forEach(element => {
            const elementHeight = element.clientHeight;
            element.style.height = (windowHeight > elementHeight ? windowHeight : elementHeight) + 'px';
        });
    }
}

window.addEventListener('load', setHeroContainerHeight);
window.addEventListener('resize', setHeroContainerHeight);
